/**
 * Sprint 3 — original educational task visuals (NZ left-side / RHD context).
 * Maps EXISTING certified task_id / detailed category keys only — no new storage keys.
 */
export const TASK_VISUAL_BY_ID = {
  "ql-mirrors": "mirrors",
  "ql-three-checks": "threeChecks",
  "ql-general-scanning": "scanning",
  "ql-moving-off": "movingOff",
  "ql-pulling-over": "pullingOver",
  "ql-smooth-stopping": "smoothStop",
  "ql-lane-position": "lanePosition",
  "ql-lane-change": "laneChange",
  "ql-parked-vehicles": "parkedVehicles",
  "ql-meeting-traffic": "meetingTraffic",
  "ql-meeting-points": "meetingPoints",
  "ql-divergent-movement": "divergentMovement",
  "ql-gap-selection": "gapSelection",
  "ql-give-way": "giveWay",
  "ql-stop-signs": "stopSign",
  "ql-traffic-lights": "trafficLights",
  "ql-intersections": "intersection",
  "ql-open-junction": "openJunction",
  "ql-closed-junction": "closedJunction",
  "ql-roundabouts": "roundabout",
  "ql-flush-median-right": "flushMedian",
  "ql-t2-lanes": "t2",
  "ql-t3-lanes": "t3",
  "ql-bus-lanes": "busLane",
  "ql-railway-crossing": "railway",
  "ql-parallel-parking": "parallelPark",
  "ql-bay-parking": "bayPark",
  "ql-reversing": "reversing",
  "ql-three-point": "threePoint",
  "ql-u-turn": "uTurn",
  "ql-following-distance": "following",
  "ql-speed-management": "speed",
  "ql-merging": "merging",
  "ql-motorway": "motorway",
  "ql-open-road": "openRoad",
  "ql-pedestrians": "pedestrian",
  "ql-cyclists": "cyclist",
  "ql-hazard-observation": "hazard",
};

/** Detailed Assessment category → shared visual kind (reuse Quick Lesson system). */
export const DETAILED_CATEGORY_VISUAL = {
  "det-roundabouts": "roundabout",
  "det-lane-change": "laneChange",
  "det-flush-median": "flushMedian",
  "det-moving-off": "movingOff",
  "det-pulling-over": "pullingOver",
  "det-railway": "railway",
  "det-special-lanes": "t2",
  "det-u-turn": "uTurn",
  "det-meeting-points": "meetingPoints",
  "det-divergent-movement": "divergentMovement",
  "det-open-junction": "openJunction",
  "det-closed-junction": "closedJunction",
};

export function visualKindForTaskId(taskId) {
  return TASK_VISUAL_BY_ID[taskId] || "generic";
}

export function visualKindForDetailedCategory(categoryId) {
  return DETAILED_CATEGORY_VISUAL[categoryId] || "generic";
}
